import * as React from 'react';
import { FeatureIcon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const ProductDetailFeatures = ({ productFeatures  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("ul", {
        className: "product-detail-features"
    }, productFeatures.map(({ type , iconName , labelKey  })=>/*#__PURE__*/ React.createElement("li", {
            className: "product-detail-features__feature",
            key: type
        }, /*#__PURE__*/ React.createElement(FeatureIcon, {
            name: iconName,
            size: 38
        }), getLabel(labelKey))
    ));
};

export { ProductDetailFeatures };
//# sourceMappingURL=ProductDetailFeatures.js.map
